import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl font-bold text-white">{siteConfig.name}</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">视频分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">使用条款</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@jp-kr-video.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-0000</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-base"></i>
                <span>JPKR_Video</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}